<template>
  <v-container>
    <div
      v-if="!checkIfPermission('view wallet', admin.permissions)"
      class="w-100 h-100 d-flex justify-center align-center"
    >
      <h1 class="error--text">You don't have access to this page</h1>
    </div>
    <div v-else>
      <h1 class="mb-5">Crypto Wallet History</h1>
      <user-details-min :userId="minUserId" :open.sync="openMin" />
      <v-row>
        <v-col>
          <v-tabs v-model="activeTab">
            <v-tab>Debit</v-tab>
            <v-tab>Credit</v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-card flat color="white">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="coinDebit"
                    :items="coinOptions"
                    :loading="loadingCoins"
                    label="Filter by Coin"
                    clearable
                    single-line
                    hide-details
                    class="mr-3"
                    style="max-width: 200px"
                  ></v-select>
                  <v-select
                    v-model="categoryDebit"
                    :items="categoryOptions"
                    label="Filter by Category"
                    clearable
                    single-line
                    hide-details
                    class="mr-3"
                    style="max-width: 200px"
                  ></v-select>
                  <!-- Hidden until the API supports `keyword` on
                       /crypto-wallets/admin/wallet-histories — until then it is
                       treated as a literal filter and returns 0 rows.
                  <v-text-field
                    v-model="searchDebit"
                    append-icon="mdi-magnify"
                    label="Search..."
                    single-line
                    hide-details
                  ></v-text-field>
                  -->
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="arrangedTransaction"
                  :items-per-page="perPage"
                  :loading="loadingTransaction"
                  :footer-props="{
                    itemsPerPageOptions: [5, 10, 15, 25, 50, 100]
                  }"
                  @update:items-per-page="updateItemPerPage"
                  @update:page="updatePage"
                  :server-items-length="apiData.total"
                >
                  <template v-slot:[`item.user`]="{ item }">
                    <!-- <router-link
                  :to="{ name: 'ViewUser', params: { id: item.user_id } }"
                  class="font-weight-medium text-capitalize d-block"
                  >{{ item.user }}</router-link
                > -->
                    <span
                      class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                      @click="openMinDialog(item.user_id)"
                    >
                      {{ item.user }}
                    </span>
                  </template>

                  <template v-slot:[`item.createdAt`]="{ item }">
                    <span>{{
                      new Date(item.createdAt).toLocaleDateString()
                    }}</span>
                  </template>

                  <!-- <template v-slot:[`item.date`]="{ item }">
                <small class="font-weight-medium">{{ item.date }}</small>
              </template> -->
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>
                      <span class="grey--text text--darken-2">{{
                        item.currency
                      }}</span>
                      {{ numberWithCommas(Number(item.amount)) }}</span
                    >
                  </template>
                </v-data-table>
                <fund-details
                  :actionProgress.sync="progress"
                  :open.sync="transactionOpen"
                  :transaction="transaction"
                />
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat color="white">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="coinCredit"
                    :items="coinOptions"
                    :loading="loadingCoins"
                    label="Filter by Coin"
                    clearable
                    single-line
                    hide-details
                    class="mr-3"
                    style="max-width: 200px"
                  ></v-select>
                  <v-select
                    v-model="categoryCredit"
                    :items="categoryOptions"
                    label="Filter by Category"
                    clearable
                    single-line
                    hide-details
                    class="mr-3"
                    style="max-width: 200px"
                  ></v-select>
                  <!-- Hidden until the API supports `keyword` — see debit tab.
                  <v-text-field
                    v-model="searchCredit"
                    append-icon="mdi-magnify"
                    label="Search..."
                    single-line
                    hide-details
                  ></v-text-field>
                  -->
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="arrangedTransactionCredit"
                  :items-per-page="perPage"
                  :loading="loadingTransactionCredit"
                  :footer-props="{
                    itemsPerPageOptions: [5, 10, 15, 25, 50, 100]
                  }"
                  @update:items-per-page="updateItemPerPageCredit"
                  @update:page="updatePageCredit"
                  :server-items-length="apiDataCredit.total"
                >
                  <template v-slot:[`item.user`]="{ item }">
                    <!-- <router-link
                  :to="{ name: 'ViewUser', params: { id: item.user_id } }"
                  class="font-weight-medium text-capitalize d-block"
                  >{{ item.user }}</router-link
                > -->
                    <span
                      class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                      @click="openMinDialog(item.user_id)"
                    >
                      {{ item.user }}
                    </span>
                  </template>

                  <template v-slot:[`item.createdAt`]="{ item }">
                    <span>{{
                      new Date(item.createdAt).toLocaleDateString()
                    }}</span>
                  </template>

                  <!-- <template v-slot:[`item.date`]="{ item }">
                <small class="font-weight-medium">{{ item.date }}</small>
              </template> -->
                  <template v-slot:[`item.amount`]="{ item }">
                    <span>
                      <span class="grey--text text--darken-2">{{
                        item.currency
                      }}</span>
                      {{ numberWithCommas(Number(item.amount)) }}</span
                    >
                  </template>
                </v-data-table>
                <!-- <delete-dialog :open.sync="dialogDelete" type="sales" /> -->
                <fund-details
                  :actionProgress.sync="progress"
                  :open.sync="transactionOpen"
                  :transaction="transaction"
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import fundDetails from '../../../components/fundDetails.vue'
import cryptoWalletApi from '../../../api/admin/crypto-wallets'
import dataApi from '../../../api/systemData'
import { mapState } from 'vuex'
import UserDetailsMin from '../../../components/userDetailsMin.vue'
import { numberWithCommas } from '../../../utils/helpers'
import _ from 'lodash'

export default {
  components: {
    fundDetails,
    UserDetailsMin
  },
  data: () => ({
    numberWithCommas,
    activeTab: null,
    openMin: false,
    minUserId: '',
    progress: 'starting',
    searchCredit: '',
    searchDebit: '',
    categoryDebit: null,
    categoryCredit: null,
    coinDebit: null,
    coinCredit: null,
    coins: [],
    loadingCoins: false,
    search: '',
    transactionOpen: false,
    dialogDelete: false,
    headers: [
      {
        text: 'User',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Amount',
        value: 'amount'
      },
      {
        text: 'Balance',
        value: 'balance'
      },
      {
        text: 'Coin',
        value: 'currency'
      },
      // {
      //   text: 'Currency Rate',
      //   value: 'currentRate'
      // },
      {
        text: 'Date',
        value: 'createdAt'
      },
      {
        text: 'Reversed',
        value: 'reversed'
      }
    ],
    transactions: [],
    transactionsCredit: [],
    transaction: {},
    perPage: 10,
    loadingTransaction: false,
    loadingTransactionCredit: false,
    apiData: {},
    apiDataCredit: {},
    lastPage: 1,
    lastPageCredit: 1
  }),
  created() {
    this.getCoins()
    this.getTransactions(0)
    this.getTransactionsCredit(0)
    this.debounceSearch = _.debounce(this.searchData, 500)
    this.debounceSearchCredit = _.debounce(this.searchDataCredit, 500)
  },
  watch: {
    searchCredit(newValue) {
      if (newValue === '') {
        this.getTransactionsCredit(0)
        return
      }
      this.debounceSearchCredit()
    },
    searchDebit(newValue) {
      if (newValue === '') {
        this.getTransactions(0)
        return
      }
      this.debounceSearch()
    },
    categoryDebit(newValue) {
      if (this.searchDebit === '') {
        this.getTransactions(0)
      } else {
        this.debounceSearch()
      }
    },
    categoryCredit(newValue) {
      if (this.searchCredit === '') {
        this.getTransactionsCredit(0)
      } else {
        this.debounceSearchCredit()
      }
    },
    coinDebit() {
      this.lastPage = 1
      this.getTransactions(0)
    },
    coinCredit() {
      this.lastPageCredit = 1
      this.getTransactionsCredit(0)
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admin.admin
    }),
    arrangedTransaction() {
      if (this.transactions.length !== 0) {
        return this.transactions.map((transaction) => ({
          ...transaction,
          id: transaction._id,
          user: transaction.user ? transaction.user.username : '',
          email: transaction.user ? transaction.user.email : '',
          name: transaction.user
            ? transaction.user.fname + ' ' + transaction.user.lname
            : '',
          user_id: transaction.user ? transaction.user._id : '',
          reversed: transaction.reversed ? 'Yes' : 'No',
          currency: transaction?.coin?.symbol,
          balance: transaction.balance
        }))
      }
      return []
    },
    arrangedTransactionCredit() {
      if (this.transactionsCredit.length !== 0) {
        return this.transactionsCredit.map((transaction) => ({
          ...transaction,
          id: transaction._id,
          user: transaction.user ? transaction.user.username : '',
          email: transaction.user ? transaction.user.email : '',
          name: transaction.user
            ? transaction.user.fname + ' ' + transaction.user.lname
            : '',
          user_id: transaction.user ? transaction.user._id : '',
          reversed: transaction.reversed ? 'Yes' : 'No',
          currency: transaction?.coin?.symbol,
          balance: transaction.balance
        }))
      }
      return []
    },
    coinOptions() {
      return this.coins.map((coin) => ({
        text: coin.symbol
          ? `${coin.symbol.toUpperCase()} - ${coin.name}`
          : coin.name,
        value: coin._id
      }))
    },
    categoryOptions() {
      const activeTab = this.activeTab
      if (activeTab === 0) {
        return [
          { text: 'Withdraw', value: 'withdraw' },
          { text: 'Swap', value: 'swap' },
          { text: 'Transfer', value: 'transfer' },
          { text: 'Purchase', value: 'purchase' }
        ]
      } else if (activeTab === 1) {
        return [
          { text: 'Deposit', value: 'deposit' },
          { text: 'Swap', value: 'swap' },
          { text: 'Transfer', value: 'transfer' },
          { text: 'Sale', value: 'sale' }
        ]
      }
      return []
    }
  },
  methods: {
    openMinDialog(id) {
      this.openMin = true
      this.minUserId = id
    },
    async getCoins() {
      this.loadingCoins = true
      const res = await dataApi.data().getData('admin', {
        type: 'currency',
        params: { limit: 0 }
      })
      this.loadingCoins = false
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage?.message || 'Unable to load the coin list',
          error: true,
          status: true
        })
        return
      }
      this.coins = (res.data.data.data || []).slice().sort((a, b) => {
        return String(a.symbol || a.name).localeCompare(
          String(b.symbol || b.name)
        )
      })
    },
    async load(type, offset = 0) {
      const credit = type === 'credit'
      const loadingKey = credit
        ? 'loadingTransactionCredit'
        : 'loadingTransaction'
      this[loadingKey] = true

      const params = {
        populate: ['user', 'coin'],
        limit: this.perPage,
        offset,
        type
      }
      const keyword = credit ? this.searchCredit : this.searchDebit
      if (keyword) params.keyword = keyword
      const category = credit ? this.categoryCredit : this.categoryDebit
      if (category) params.category = category
      const coin = credit ? this.coinCredit : this.coinDebit
      if (coin) params.coin = coin

      const res = await cryptoWalletApi.data().getWalletHistory(params)
      this[loadingKey] = false

      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage?.message ||
            `${res.internalError?.message}, please try again`,
          error: true,
          status: true
        })
        return
      }

      if (credit) {
        this.transactionsCredit = res.data.data.data
        this.apiDataCredit = res.data.data.meta
      } else {
        this.transactions = res.data.data.data
        this.apiData = res.data.data.meta
      }
    },
    searchData() {
      this.lastPage = 1
      return this.load('debit', 0)
    },
    searchDataCredit() {
      this.lastPageCredit = 1
      return this.load('credit', 0)
    },
    updatePage(page) {
      if (this.lastPage - page > 2) {
        page = this.lastPage
      }
      this.lastPage = page
      this.getTransactions((page - 1) * this.perPage)
    },
    updatePageCredit(page) {
      if (this.lastPageCredit - page > 2) {
        page = this.lastPageCredit
      }
      this.lastPageCredit = page
      this.getTransactionsCredit((page - 1) * this.perPage)
    },
    updateItemPerPage(count) {
      this.perPage = count
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    updateItemPerPageCredit(count) {
      this.perPage = count
      this.getTransactionsCredit((this.lastPageCredit - 1) * this.perPage)
    },
    getTransactions(offset) {
      return this.load('debit', offset)
    },
    getTransactionsCredit(offset) {
      return this.load('credit', offset)
    }
  }
}
</script>

<style></style>
